import { goAxios } from '@/interceptors/axios';

class ManifestService {
  getManifestSets(date) {
    return goAxios.get(`/api/manifests?date=${encodeURIComponent(date)}`);
  }

  addOrdersToManifest(manifestSetId, orders) {
    return goAxios.post(`/api/manifests/${manifestSetId}/orders`, { orders });
  }
}

export default new ManifestService();
